import navigationConfig from "configs/navigation.config";
import getDomain from "utils/getDomain";

/**
 * Same rule as side nav donation item (hideDomains on navigation.config).
 */
export default function isDonationBottomNavHidden() {
  const donationItem = navigationConfig.find((n) => n.key === "donation");
  const domains = donationItem?.hideDomains;
  if (!domains?.length) {
    return false;
  }
  return domains.includes(getDomain());
}
